import { createFileRoute } from '@tanstack/react-router';

interface EditSearch {
  retriggerMode: 'reset_all' | 'continue';
  startStep?: number;
}

export const Route = createFileRoute('/t/signing-requests/$requestId_/edit')({
  // hideShell → AppShell (the only Breadcrumbs renderer) isn't mounted, so no
  // breadcrumb staticData is needed.
  staticData: {
    hideShell: true,
  },
  validateSearch: (search: Record<string, unknown>): EditSearch => ({
    retriggerMode: search.retriggerMode === 'continue' ? 'continue' : 'reset_all',
    startStep: search.startStep != null ? Number(search.startStep) : undefined,
  }),
});
